import {
  Button,
  Card,
  CardContent,
  IconButton,
  Typography
} from '@mui/material'
import LeadContactoSelector from '../../../components/form/LeadContactoSelector/LeadContactoSelector'
import TelefonoInput from '../../../components/form/TelefonoInput/TelefonoInput'
import { getPhoneValidationState, phoneToString } from '../../../utils/phone'
import css from './DatosTelefono.module.css'

const DatosTelefono = ({ telefonos, onChange }) => {
  const handleAddTelefono = () => {
    onChange([
      ...telefonos,
      { nombre: '', telefono: '', prefijoInternacional: '' }
    ])
  }

  const handleRemoveTelefono = index => {
    const newTelefonos = telefonos.filter((_, i) => i !== index)
    onChange(newTelefonos)
  }

  const handleUpdateTelefono = (index, field, value) => {
    const newTelefonos = [...telefonos]
    newTelefonos[index] = {
      ...newTelefonos[index],
      [field]: value
    }
    onChange(newTelefonos)
  }

  const handleUpdateTelefonoWithDetails = (index, event, details) => {
    const newTelefonos = [...telefonos]
    newTelefonos[index] = { ...newTelefonos[index], ...details }
    onChange(newTelefonos)
  }

  return (
    <Card className={css.card}>
      <CardContent className={css.cardContent}>
        <Typography variant='h6' className={css.cardTitle}>
          Datos de teléfono
        </Typography>
        {telefonos.map((telefono, index) => (
          <div key={index} className={css.row}>
            <div className={css.inputsContainer}>
              <LeadContactoSelector
                name={`contacto-${index}`}
                className={css.contactoInput}
                value={telefono.nombre}
                onChange={(_event, value) =>
                  handleUpdateTelefono(index, 'nombre', value)
                }
              />
              <TelefonoInput
                name={`telefono-${index}`}
                className={css.telefonoInput}
                label='Teléfono'
                value={phoneToString(telefono)}
                onChange={(event, details) =>
                  handleUpdateTelefonoWithDetails(index, event, details)
                }
              />
            </div>
            <div className={css.actions}>
              <IconButton
                className={css.removeButton}
                onClick={() => handleRemoveTelefono(index)}
                size='small'
                color='error'
                disabled={index === 0}
              >
                <span className='material-icons'>delete</span>
              </IconButton>
              <span
                className={`material-icons ${css.icon}`}
                data-status={getPhoneValidationState(telefono)}
              >
                {getPhoneValidationState(telefono) === 'success' &&
                  'check_circle'}
                {getPhoneValidationState(telefono) === 'warning' && 'warning'}
                {getPhoneValidationState(telefono) === 'error' && 'error'}
              </span>
            </div>
          </div>
        ))}
        <Button
          className={css.addButton}
          variant='outlined'
          color='primary'
          onClick={handleAddTelefono}
          startIcon={<span className='material-icons'>add</span>}
        >
          Añadir teléfono
        </Button>
      </CardContent>
    </Card>
  )
}

export default DatosTelefono
